<div class="sidebar" [ngClass]="isClosed ? 'closedSidebar' : ''">
  <div class="sidebar-body">
    <div class="logo-details">
      <i class="pi pi-bars text-white" [ngClass]="isClosed ? 'arrow closedArrow' : 'arrow'"
        (click)="toggleSidebar()"></i>
      @if (logoImg) {
      <img class="logo_company" src="{{ logoImg }}" alt="logo company" (click)="goHome()" width="100" />
      }
      @if (!logoImg) {
      <span class="logo_name" (click)="goHome()">
        SmartGreen
      </span>
      }
    </div>
    <div class="company-select" [ngClass]="{ 'company-select-open': !isClosed }">
      <p-select appendTo="body" [options]="filteredCompanies" optionLabel="name" optionValue="id"
        [formControl]="companyFormControl" [filter]="true" filterBy="name"
        placeholder="{{ 'sidebar.company' | translate }}" (onChange)="companySelect()"
        emptyFilterMessage="{{ 'sidebar.no-results' | translate }}"
        emptyMessage="{{ 'sidebar.no-results' | translate }}">
      </p-select>
    </div>
    <hr />

    <li>
      <div class="icon-link" (click)="goHome()">
        <i class="pi pi-globe menu-icon"></i>
        <span class="link_name"> {{ "sidebar.map" | translate }} </span>
      </div>
    </li>

    @if(!isMapOnly){
    <li>
      <div class="icon-link" (click)="openCloseReportSubMenu()">
        <i class="pi pi-chart-bar menu-icon"></i>
        <span class="link_name"> {{ "sidebar.reports" | translate }} </span>
      </div>

      <ul class="sub-menu" [ngClass]="isReportMenuOpen ? 'sub-menu-open' : ''">
        <li (click)="goToReport()">
          <a> {{ "sidebar.generate-reports" | translate }} </a>
        </li>
        <li (click)="goToReportCharts()">
          <a> {{ "sidebar.report-charts" | translate }} </a>
        </li>
        @if (isIpMinas) {
        <li (click)="goToAudit()">
          <a> {{ "sidebar.audit" | translate }} </a>
        </li>
        }
      </ul>
    </li>
    <li>
      <div class="icon-link">
        <i class="pi pi-cog menu-icon" (click)="openCloseCommandsSubMenu()"></i>
        <span class="link_name" (click)="openCloseCommandsSubMenu()">
          {{ "sidebar.commands" | translate }}
        </span>
      </div>

      <ul class="sub-menu" [ngClass]="isCommandMenuOpen ? 'sub-menu-open' : ''">
        <li (click)="goToCommands()">
          <a> {{ "sidebar.commands" | translate }} </a>
        </li>
        <li (click)="goToScheduling()">
          <a> {{ "sidebar.scheduling" | translate }} </a>
        </li>
      </ul>
    </li>

    <li (click)="goToServiceOrder()">
      <div class="icon-link">
        <i class="pi pi-file-edit menu-icon"></i>
        <span class="link_name">
          {{ "sidebar.service-order" | translate }}
        </span>
      </div>
    </li>

    <li>
      <div class="icon-link">
        <i class="pi pi-exclamation-triangle menu-icon" (click)="openCloseAlertSubMenu()"></i>
        <span class="link_name" (click)="openCloseAlertSubMenu()">
          {{ "sidebar.alerts" | translate }}
        </span>
      </div>
      <!--
      <ul class="sub-menu" [ngClass]="isAlertsMenuOpen ? 'sub-menu-open' : ''">
        <li (click)="goToAlertRules()">
          <a> {{ "sidebar.alert-rules" | translate }} </a>
        </li>
      </ul> -->

      <ul class="sub-menu" [ngClass]="isAlertsMenuOpen ? 'sub-menu-open' : ''">
        <li (click)="goToSystemAlerts()">
          <a> {{ "sidebar.system-alerts" | translate }} </a>
          <!-- <a>Gerados pelo sistema</a> -->
        </li>
      </ul>
      <ul class="sub-menu" [ngClass]="isAlertsMenuOpen ? 'sub-menu-open' : ''">
        <li (click)="goToEquipmentAlerts()">
          <a> {{ "sidebar.equipment-alerts" | translate }} </a>
          <!-- <a>Gerados pelo equipamento</a> -->
        </li>
      </ul>
    </li>

    <li>
      <div class="icon-link">
        <i class="pi pi-users menu-icon" (click)="openCloseUserSubMenu()"></i>
        <span class="link_name" (click)="openCloseUserSubMenu()">
          {{ "sidebar.users" | translate }}
        </span>
      </div>

      <ul class="sub-menu" [ngClass]="isUserMenuOpen ? 'sub-menu-open' : ''">
        <li (click)="goToManageUser()">
          <a> {{ "sidebar.manage-user" | translate }} </a>
        </li>
        <li (click)="goToPermissionsGroup()">
          <a> {{ "sidebar.permissions-group" | translate }} </a>
        </li>
      </ul>
    </li>

    <li>
      <div class="icon-link">
        <i class="pi pi-file menu-icon" (click)="goToLogs()"></i>
        <span class="link_name" (click)="goToLogs()">
          {{ "sidebar.logs" | translate }}
        </span>
      </div>
    </li>

    <li>
      <div class="icon-link">
        <i class="pi pi-file-import menu-icon" (click)="goToImportsCSV()"></i>
        <span class="link_name" (click)="goToImportsCSV()">
          {{ "sidebar.importsCSV" | translate }}
        </span>
      </div>
    </li>

    <li>
      <div class="icon-link">
        <i class="pi pi-folder-plus menu-icon" (click)="goToRegister()"></i>
        <span class="link_name" (click)="goToRegister()">
          {{ "sidebar.register" | translate }}
        </span>
      </div>
    </li>
    }
    <li>
      <div class="icon-link" (click)="viewAllTimeZones()">
        <i class="pi pi-clock menu-icon" (click)="viewAllTimeZones()"></i>
        <span class="link_name"> {{ "sidebar.timezone" | translate }} </span>
      </div>
    </li>

    <div class="translations">
      <div class="pt-btn" [ngClass]="selectedLanguage === 'pt' ? 'selected-language' : null"
        (click)="useLanguage('pt')"></div>
      <div class="es-btn" [ngClass]="selectedLanguage === 'es' ? 'selected-language' : null"
        (click)="useLanguage('es')"></div>
      <div class="us-btn" [ngClass]="selectedLanguage === 'us' ? 'selected-language' : null"
        (click)="useLanguage('us')"></div>
    </div>

    <div [ngClass]="isClosed ? 'profile-details isClosed' : 'profile-details'">
      <div class="name-job">
        <i class="pi pi-sign-out profile-icon" (click)="logout()"></i>
        <div class="profile_name" (click)="goToProfile()" title="Ir para seu perfil">
          <span>{{ fullName[0] }} {{ fullName[1] }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="displayTimezoneDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '35rem' }" [breakpoints]="{ '960px': '75vw', '640px': '95vw'}"
  [header]="'sidebar.select-timezone' | translate" styleClass="timezone-dialog">

  <div>
    <p-autoComplete appendTo="body" [(ngModel)]="selectedTimeZone" [ngModelOptions]="{ standalone: true }"
      [suggestions]="filteredTimezones" (completeMethod)="filterTimeZone($event)" field="display" optionLabel="display"
      [dropdown]="true" [forceSelection]="true" [virtualScroll]="true" [virtualScrollItemSize]="34" [placeholder]="
        'sidebar.select-timezone-text' | translate
      ">
    </p-autoComplete>
    <h3>
      {{ "sidebar.or-text" | translate }}
    </h3>

    <p-button [label]="
        ('sidebar.default-timezone' | translate)
        + ' (' + formattedBrowserTimezone + ')'
      " severity="secondary" (onClick)="removeTimeZone()">
    </p-button>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button [label]="'sidebar.cancel-button' | translate" severity="secondary"
        (onClick)="displayTimezoneDialog = false">
      </p-button>
      <p-button [label]="'sidebar.save-button' | translate" severity="success" (onClick)="saveTimeZone()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>